import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class FetchRecordingSegments {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly recordingId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchRecordingSegments;
